import moment from 'moment';
import actions from './actions';
import { callAPI } from '../../mtn/util';

const {
  userBegin,
  userSuccess,
  userErr,
} = actions;

const userGetData = () => {
  return async (dispatch) => {
    try {
      dispatch(userBegin());

      const events = await callAPI("Events/ByOwner", {
        OwnerId : 0,
        Status : 1,
        Full : 1
      })
      
      const readers = await callAPI("Readers/ByOwner", {
        OwnerId : 0,
        Status : 1,
        Full : 1
      })

      const calendarEvents = events.map(event=>({
        date:[
          moment(event.FromDate).format("MM/DD/YYYY"),
          moment(event.ToDate).format("MM/DD/YYYY")
        ],
        description: event.EvtDesc,
        id: event.EvtId,
        label: "success",
        time:[
          event.FromDate,
          event.ToDate
        ],
        title: event.EvtName,
        type: "event",
      }))

      const data = {
        events,
        readers,
        calendarEvents,
      }

      dispatch(userSuccess(data));
    } catch (err) {
      dispatch(userErr(err));
    }
  };
};



export {
  userGetData
};
